import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import LineChart from './../../../../../chartUtilities/lineChart/lineChart';
import DonutChart from './../../../../../chartUtilities/donutChart/donutChart';
import Loader from './../../../../../utilityComponents/Loader';
import Message from './../../../../../utilityComponents/Message';
import PropTypes from 'prop-types';

function LaneManagementKPI(props) {
    return (
        <Container>
            { props.loading ?
             <Loader /> :
             props.error ?
             (
                <Message variant={'danger'}>
                    {props.error}
                </Message>
             ): (
             <>
                <Row>
                    <Col md={12} xl={12}>
                        <Row>
                            <Col md={12} xl={12}>
                                <h4>Adjacent Lane Present</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} xl={12}>
                                <Container>
                                    { (props.laneAvailability['availability'] === 0 && props.laneAvailability['nonAvailability'] === 0) ?
                                     ( <Message variant={'info'}>No Data Available</Message> ) :
                                     (
                                        <DonutChart
                                            title={"Adjacent Lane Present"}
                                            name={""}
                                            labels={["Adjacent Lane Present", "Adjacent Lane Absent"]}
                                            values={[props.laneAvailability['availability'],
                                                props.laneAvailability['nonAvailability']]}
                                        />
                                     )
                                     }
                                </Container>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} xl={12}>
                        <Row>
                            <Col md={12} xl={12}>
                                <h4>Lane Offset ( [ - ] left of lane center; [ + ] right of lane center)</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} xl={12}>
                                <Container>
                                    { (props.laneOffset.xAxis.length === 0 ||
                                        props.laneOffset.yAxis.length === 0) ?
                                         (<Message variant={'info'}>No Data Available</Message>) :
                                         (
                                            <LineChart
                                                title={'Lane Offset'}
                                                xAxisTitle={'Time (s)'}
                                                yAxisTitle={'Lane Offset (m)'}
                                                xAxis={props.laneOffset.xAxis}
                                                yAxis={props.laneOffset.yAxis}
                                            />
                                     )}
                                </Container>
                            </Col>
                        </Row>
                    </Col>
                </Row>
             </>
             )}
        </Container>
    )
}

const mapStateToProps = (state) => ({
    loading: state.dashboardGraphData.laneManagementKPI.loading,
    error: state.dashboardGraphData.laneManagementKPI.error,
    laneAvailability: state.dashboardGraphData.laneManagementKPI.laneAvailability,
    laneOffset: state.dashboardGraphData.laneManagementKPI.laneOffset
})

LaneManagementKPI.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    laneAvailability: PropTypes.shape({
        availability: PropTypes.number,
        nonAvailability: PropTypes.number
    }),
    laneOffset: PropTypes.shape({
        xAxis: PropTypes.array,
        yAxis: PropTypes.array
    })
};

export default connect(mapStateToProps, undefined)(LaneManagementKPI);